import { z } from "zod";

import { createMessageDataModel } from "@/domains/messages/factories/create-message-data-model";
import { createMessagesDataModel } from "@/domains/messages/factories/create-messages-data-model";
import { MESSAGE_TYPE } from "@/domains/messages/models/constants";

const messageTypeSchema = z.enum(MESSAGE_TYPE);

export const messageResponseSchema = z.object({
  id: z.number(),
  threadId: z.number(),
  type: messageTypeSchema,
  content: z.string(),
  metadata: z.union([z.array(z.string()), z.record(z.string(), z.unknown())]),
  createdAt: z.string(),
});

export const messageDataModelSchema = messageResponseSchema.transform(createMessageDataModel);

export const messagesDataModelSchema = z
  .array(messageDataModelSchema)
  .transform(createMessagesDataModel);
